<template>
    <div class='header'>
        <div class="hc-wrapper clearfix">
            <div class="hc-left-side">
                <a href="http://5sing.kugou.com/index.html" target="_blank">
                    <img class="logo" src="http://static.5sing.kugou.com/subject/resource/common/images/1.png" />
                </a>
            </div>

            <div class="hc-right-side clearfix">
                <ul class="hc-nav-panel clearfix">
                    <li><a href="http://5sing.kugou.com/index.html" target="_blank">5SING首页</a></li>
                    <li><a href="http://5sing.kugou.com/yc/index.html" target="_blank">原创</a></li>
                    <li><a href="http://5sing.kugou.com/fc/index.html" target="_blank">翻唱</a></li>
                    <li><a href="http://5sing.kugou.com/bz/index.shtml" target="_blank">伴奏</a></li>
                    <li><a href="http://5sing.kugou.com/artists/" target="_blank">音乐人</a></li>
                    <li><a href="http://club.5sing.kugou.com/" target="_blank">圈子</a></li>
                    <li><a href="http://huodong.5sing.kugou.com/" target="_blank">活动专区</a></li>
                </ul>

                <div class="hc-user-panel"  v-show="loginMsg.isLogin == false" >
                    <a href="http://5sing.kugou.com/login/">登录</a>
                </div>
                <div class="hc-user-panel" v-show="loginMsg.isLogin == true" >
                    <a target="_blank"   >
                        <img class="avatar" onerror="this.src='http://img2.5sing.kgimg.com/m/T1LodVBTbT1RXrhCrK_35_35.jpg'"  v-bind:src="loginMsg.img"/>
                        <span class="nickname" >{{loginMsg.nickname}}</span>
                    </a>
                    <div class="user-menu">
                        <i class="arr-icon"></i>
                        <ul>
                            <li><a href="http://5sing.kugou.com/my/writing/fc" target="_blank">作品管理</a></li>
                            <li><a href="http://5sing.kugou.com/logout">退出登录</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
</template>
<script>
export default {
    name: 'headerBar',
    data() {
        return {
            loginMsg: {
                isLogin: false
            }
        }
    },
    mounted: function(){
        var _this = this;
        this.$server.login().then(function(res){
            _this.$winConfig.isLogin = res.data.isLogin;
            _this.loginMsg = res.data;
        });
    }
}
</script>
<style>
.header {
    position: absolute;
    top: 0;
    z-index: 200;
    width: 100%;
    height: 63px;
    line-height: 63px;
    font-size: 14px;
    background: url(http://static.5sing.kugou.com/subject/resource/xfz/images/3.png) repeat-x;
}
.header a {
    color: #fff;
    text-decoration: none;
}
.header a:hover {
    color: #6c0;
}
.header .hc-wrapper {
    width: 1000px;
    margin: 0 auto;
}
.header .hc-left-side {
    float: left;
}
.header .hc-right-side {
    float: right;
}
.header .logo {
    margin-top: 10px;
}
.header .hc-nav-panel {
    float: left;
}
.header .hc-nav-panel li {
    float: left;
    margin-right: 24px;
}
.header .hc-nav-panel .login-item {
    margin: 0 0 0 16px;
}
.header .hc-nav-panel .login-item.status-hidden {
    display: none;
}
.header .hc-user-panel {
    position: relative;
    float: left;
    margin-left: 16px;
}
.header .hc-user-panel .avatar {
    height: 35px;
    height: 35px;
    margin-top: 12px;
    border-radius: 50%;
}
.header .hc-user-panel .nickname {
    position: relative;
    display: inline-block;
    width: 85px;
    vertical-align: -12px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.header .user-menu {
    position: absolute;
    top: 55px;
    left: 43px;
    width: 85px;
    border-top: 2px solid #32b150;
    line-height: 30px;
    background: #fff;
    font-size: 13px;
    text-align: center;
    box-shadow: 0 0 5px #999;
    opacity: 0;
    visibility: hidden;
    transition: all .5s;
    z-index: 10;
}
.header .hc-user-panel:hover .user-menu {
    top: 50px;
    opacity: 1;
    visibility: visible;
}
.header .user-menu .arr-icon {
    position: absolute;
    top: -7px;
    left: 50%;
    display: block;
    width: 14px;
    height: 5px;
    margin-left: -7px;
    background: url(http://static.5sing.kugou.com/subject/resource/common/images/2.png) no-repeat;
}
.header .user-menu a {
    color: #3f3f3f;
}
.header .user-menu a:hover {
    color: #6c0;
}
</style>





// WEBPACK FOOTER //
// src/components/header-bar.vue